import { makeStylesheetLink } from "@self/stylesheet";

export abstract class CustomElement extends HTMLElement {

	public shadow: ShadowRoot;

	constructor(...nodes: (Node | string)[]) {
		super();
		this.shadow = this.attachShadow({ mode: "open" });
		this.shadow.append(makeStylesheetLink(), ...nodes);
	}
}

export const customElement = (name: string) => (value: Function, context: ClassDecoratorContext<CustomElementConstructor>) => {
	context.addInitializer(function () {
		customElements.define(name, this);
	});
};

export const bound = <T>(value: Function, context: ClassMethodDecoratorContext<T>) => {
	context.addInitializer(function (this: any) {
		this[context.name] = value.bind(this);
	});
};
